interface KpiProps {
  label: string;
  value: string;
  delta?: { value: string; trend: 'up' | 'down' | 'flat' };
  isLoading?: boolean;
}

const arrow = {
  up: '▲',
  down: '▼',
  flat: '■',
};

const Kpi = ({ label, value, delta, isLoading }: KpiProps) => (
  <div className="rounded-lg border border-slate-800 bg-slate-900/80 p-4">
    <p className="text-xs uppercase tracking-wide text-slate-400">{label}</p>
    {isLoading ? (
      <div className="mt-3 h-7 w-24 animate-pulse rounded bg-slate-800" />
    ) : (
      <p className="mt-2 text-2xl font-semibold text-white">{value}</p>
    )}
    {!isLoading && delta && (
      <p className="mt-1 text-xs text-slate-400">
        {arrow[delta.trend]} {delta.value} vs prior period
      </p>
    )}
  </div>
);

export default Kpi;
